// The CC agent pastes a phone in E.164 form — a leading "+", the country code, then the
// national number — from their ticketing source, which already carries the "+" prefix.
// So detection accepts any well-formed international number, not just Spain: a mandatory
// "+", a country code whose first digit is 1-9 (so "+0…" is not a phone), 7 to 15 digits
// in total (the E.164 ceiling), and separators (spaces, dashes, parentheses) tolerated
// and dropped. Anything else — no "+", a "00"/"0034" trunk prefix, a length outside
// 7-15, letters — is not a phone, so the bar runs no search (and a hint can be shown).
// This validates the generic E.164 shape, not per-country validity: a well-formed but
// nonexistent number still searches and resolves to "no results".
//
// Returns the normalized E.164 phone (+<digits>), used to key the search tab, or null.
const E164_PHONE = /^\+[\s()-]*[1-9][\s()-]*(?:\d[\s()-]*){6,14}$/;

export function detectPhone(input: string): string | null {
  const trimmed = input.trim();
  if (!E164_PHONE.test(trimmed)) return null;

  return `+${trimmed.replace(/\D/g, '')}`;
}
